import PropTypes from 'prop-types';
import React from 'react';
import Price from './Price';

const PriceSum = ({ price, count, initialPrice = null }) => {
  return (
    <>
      <Price price={price} initialPrice={initialPrice} />
    </>
  );
};

PriceSum.propTypes = {
  price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  count: PropTypes.number.isRequired,
  initialPrice: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default PriceSum;
